import { useNavigate } from 'react-router-dom';
import { useServiceCsrfSites } from '@/api/waap';
import { AdvancedSiteList } from '@/pages/services/waap/aiwaf/advanced-protection/AdvancedSiteList';

/**
 * Cross-Site Request Forgery (CSRF) Protection — the website list shown under the
 * Advanced Protection tab. Per-website: each row's status reflects whether
 * config.waf_csrf_strategy is enabled; Edit opens the per-site rule form.
 */
export function CsrfPanel({ serviceId, base }: { serviceId: string; base: string }) {
  const navigate = useNavigate();
  const { data: sites = [], isLoading } = useServiceCsrfSites(serviceId);

  return (
    <AdvancedSiteList
      title="Websites"
      description="CSRF protection checks the request referers against the URL list below to verify whether they have cross-site access."
      sites={sites}
      isLoading={isLoading}
      onEdit={(siteId) => navigate(`${base}/aiwaf/advanced/csrf/${siteId}`)}
    />
  );
}
